/**
 * If you change these, you'll need to add the previous ones to the
 * allLegacyUrlParts -list to keep old URLs functional.
 *
 * TODO OA: Sync these somehow with the server side functions handleGetCompanyPage etc.,
 * which generate sharing texts for entity pages
 */

export enum ViewMode {
  MAIN = 'main',
  DRILLDOWN = 'drilldown',
  INTERNAL = 'internal',
  CSRD = 'dma',
  FINANCIAL_EFFECTS = 'financial-effects',
  CLIMATE_RISK = 'climate-risk',
}

const viewModes = Object.values(ViewMode);

export function toViewMode(viewMode: string | undefined): ViewMode {
  if (!viewMode || !viewModes.includes(viewMode as ViewMode)) {
    return ViewMode.MAIN;
  } else {
    return viewMode as ViewMode;
  }
}
